module.exports = __webpack_public_path__ + "img/full2-min.9930d2f7.png";